import { useEffect } from 'react';

export function useScrollReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

    // Stagger children
    const childIO = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const kids = e.target.querySelectorAll(
            '.prob-card, .testi-card, .saving, .bfa-item, .j-step, .feat'
          );
          kids.forEach((c, i) => {
            const el = c as HTMLElement;
            el.style.opacity = '0';
            el.style.transform = 'translateY(20px)';
            el.style.transition = `opacity 0.5s ease ${i * 0.08}s, transform 0.5s ease ${i * 0.08}s`;
            setTimeout(() => {
              el.style.opacity = '1';
              el.style.transform = 'none';
            }, 80 + i * 50);
          });
          childIO.unobserve(e.target);
        });
      },
      { threshold: 0.05 }
    );

    document
      .querySelectorAll(
        '.prob-grid, .testi-scroll, .savings-grid, .bfa-inner, .journey-steps, .panel-features'
      )
      .forEach((el) => childIO.observe(el));

    return () => {
      io.disconnect();
      childIO.disconnect();
    };
  }, []);
}
